import { notSupported } from "./posList"


const str = {
  noTable: "TABLE NOT EXIST"
}

const pos = {
  "UNIONPOS": { getTableInfo: getTableInfoUnionpos },
  "OKPOS": { getTableInfo: getTableInfoOkpos },
  "OASIS_POS": { getTableInfo: getTableInfo0 },
  "EASY_POS": { getTableInfo: getTableInfo0 },
  "DUMMY_POS": { getTableInfo: getTableInfo0 },
  "ONL_POS": { getTableInfo: getTableInfo0 },
}

const posList = Object.keys(pos)

export function getTableInfo({ shopInfo, tableNo, itemOptions2 }) {
  if (!posList.includes(shopInfo.posName)) return notSupported()
  return pos[shopInfo.posName].getTableInfo({ tableNo, itemOptions2 })
}

function getTableInfoUnionpos({ tableNo, itemOptions2 }) {
  const tables = itemOptions2.TableList.filter(tbl => tbl.TableNo === parseInt(tableNo))
  if (tables.length === 0) return { err: { message: str.noTable } }

  const tableText = tables[0].TableName.includes("테이블")
    ? tables[0].TableName
    : "테이블 " + tables[0].TableNo

  const table = { ...tables[0], tableText }

  return { table }
}

function getTableInfoOkpos({ tableNo, itemOptions2 }) {
  const tables = itemOptions2.TableList.filter(tbl => {
    return parseInt(tbl.TableNo).toString() === parseInt(tableNo).toString()
  })
  if (tables.length === 0) return { err: { message: str.noTable } }

  const tableText = tables[0].TableName.includes("테이블")
    ? tables[0].TableName
    : "테이블 " + tables[0].TableName

  const table = { ...tables[0], tableText }

  return { table }
}

function getTableInfo0({ tableNo, itemOptions2 }) {
  const tables = itemOptions2.tableList.filter(tbl => {
    return parseInt(tbl.tableNo).toString() === parseInt(tableNo).toString()
  })
  if (tables.length === 0) return { err: { message: str.noTable } }

  const tableText = tables[0].tableName.includes("테이블")
    ? tables[0].tableName
    : "테이블 " + tables[0].tableName

  const table = { ...tables[0], tableText }
  return { table }
}

